import md5 from 'js-md5';
import { login as loginApi, logout as logoutApi, getInfo as getInfoApi } from '@/api/user';
import { getToken, setToken, removeToken, getJid, setJid } from '@/utils/auth';
import { resetRouter } from '@/router';
import router from '@/router';
// import { responseHandle } from '@/utils/responseHandle';


const state = {
    jsessionid: getJid(),
    token: getToken(),
    name: '',
    realm: '',
    avatar: '',
    introduction: '',
    userInfo: {},//{id, customerCode,name,realm,source,ouPath}
    roles: [], //return all router
    globalConfig: {}
};

const mutations = {
    SET_JID: (state, jid) => {
        state.jsessionid = jid;
        setJid(jid);
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
        setToken(token);
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_REALM: (state, realm) => {
        state.realm = realm;
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles;
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },
    SET_USERCONFIG: (state, config) => {
        state.globalConfig = config;
    }
};

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { username, password } = userInfo;
        return new Promise((resolve, reject) => {
            loginApi({ username: username.trim(), password: md5(password + username.trim()) }).then(response => {
                const { data } = response;
                if (response.resultCode == 1001) {
                    commit('SET_JID', data.jsessionid || '');
                    commit('SET_TOKEN', data.token || '');
                    resolve(response);
                } else {
                    reject(response);
                }

            }).catch(error => {
                reject(error);
            });
        });
    },

    unitaryLogin({ commit }, resData = {}) {
        const { jsessionid, token } = resData;
        commit('SET_JID', jsessionid || '');
        commit('SET_TOKEN', token || '');
    },

    // get user info
    getInfo({ commit, dispatch, state }) {
        return new Promise((resolve, reject) => {
            getInfoApi(state.token).then(response => {
                if (response.resultCode == 1001) {
                    const { data } = response;
                    if (!data) {
                        resolve({ response });
                        // dispatch('logout');
                        // reject('Verification failed, please Login again.');

                    } else {
                        const { user, jurisdictions: customerObj, functions: btnPermission, globalConfig: config = {} } = data;
                        const { GLOBAL = [], SYSTEM = [], ADMIN = [], NORMAL = [] } = data;
                        let roles = [];
                        if (user.realm) {
                            switch (user.realm) {
                                case 'GLOBAL':
                                    roles = [...GLOBAL, ...SYSTEM, ...NORMAL];
                                    break;
                                case 'SYSTEM':
                                    roles = [...SYSTEM, ...NORMAL];
                                    break;
                                case 'ADMIN':
                                    roles = [...ADMIN, ...NORMAL];
                                    break;
                                case 'NORMAL':
                                    roles = [...NORMAL];
                                    break;

                                default:
                                    break;
                            }
                        }
                        // roles must be a non-empty array
                        if (!roles || roles.length <= 0) {
                            reject('getInfo: roles must be a non-null array!');
                        }

                        commit('SET_ROLES', roles);
                        commit('SET_REALM', user.realm);
                        commit('SET_NAME', user.name);
                        commit('SET_USERINFO', user);
                        commit('SET_USERCONFIG', config);
                        dispatch('permission/setCustomerObj', customerObj, { root: true });
                        dispatch('permission/setBtnPermission', btnPermission, { root: true });
                        resolve({ roles, user, customerObj });
                    }
                } else {
                    // responseHandle(response.data);
                    resolve({ response });
                }

            }).catch(error => {
                reject(error);
            });
        });
    },

    //user logout
    logout({ dispatch, state }) {
        return new Promise((resolve, reject) => {
            logoutApi(state.token).then(async (res) => {
                await dispatch('logoutClear', res.data);
                resolve();
            }).catch(error => {
                reject(error);
            });
        });
    },

    logoutClear({ commit, rootState }, logoutInfo = {}) {
        let type = logoutInfo.type || '';
        let url = logoutInfo.url || '';
        commit('SET_JID', '');
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('app/SET_CURRENTCUSTOMER', '', { root: true });
        commit('app/SET_CURRENTSTORE', '', { root: true });
        commit('app/SET_CUSTOMER_OPTION', [], { root: true });
        commit('app/SET_STORE_OPTION', [], { root: true });
        commit('app/SET_CUST_FUN_CONFIG', {}, { root: true });
        commit('app/SET_LICENSE_INFO', {}, { root: true });

        removeToken();
        resetRouter();
        // dispatch('tagsView/delAllViews', null, { root: true })
        if (window.__POWERED_BY_QIANKUN__) {
            if (!rootState.global.logout) {
                rootState.global.props.setGlobalState({ logout: true });

            }
        } else {
            if (type) {
                if (type == 'REDIRECT') {
                    if (url) {
                        window.location.href = url;
                    } else {
                        router.push({ name: 'login' });
                        setTimeout(() => {
                            window.location.reload();
                        }, 0);
                    }
                } else if (type == 'VIEWPAGE') {
                    router.push({ name: 'login', query: { type: type } });
                }
            } else {
                if (url) {
                    window.location.href = url;
                } else {
                    router.push({ name: 'login' });
                    setTimeout(() => {
                        window.location.reload();
                    }, 0);
                }
            }
        }
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            commit('SET_ROLES', []);
            removeToken();
            resolve();
        });
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};